class collectionSorting extends HTMLElement {
    constructor() {
      super();

      const collectionId = document.querySelector(".collection-content").getAttribute('data-section-id');

      this.sections = {
        main: {
            sectionId: collectionId,
            nodeId: "CollectionAjaxContent"
        }
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);

      this.init();
    }

    init() {
        this.dropDownBtn = this.querySelector("[js-dropdown-btn]");
        this.sortItems = this.querySelectorAll("[js-sort-item]");

        this.sortItems.forEach( sortItem => sortItem.addEventListener("click", this.onSortChange.bind(this)));

        if(this.dropDownBtn) {
            this.dropDownBtn.addEventListener("click", () => {
                this.toggleDropdown();
            });
    
            document.addEventListener("click", (event) => {
                if(!this.contains(event.target)) {
                    this.close()
                }
            });
        }
    };

    toggleDropdown() {
        this.classList.toggle("is-open");
    };

    close() {
        this.classList.remove("is-open");
    };

    onSortChange({ currentTarget }) {
        this.queryParams = new URLSearchParams(window.location.search);
        const value = this.getSortValue(currentTarget);
        this.queryParams.set('sort_by', value);

        this.ajaxCollectionEl.classList.add("preloading");
        
        this.close();
        this.updateState(currentTarget);
        this.updateURLHash(this.queryParams);
        this.sortCollection();
    };

    getSortValue(el) {
        return el.dataset.sortValue;
    };

    updateState(el) {
        this.sortItems.forEach( item => item.classList.remove("active"));
        el.classList.add("active")
    };

    updateURLHash(searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
    };

    sortCollection() {
        const url = `${window.location.pathname}${window.location.search}&section_id=${this.sections.main.sectionId}`;
        fetch(url).then(response => {
            return response.text();
        }).then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.ajaxCollectionEl.innerHTML = doc.querySelector(`#${this.sections.main.nodeId}`).innerHTML;

            document.dispatchEvent(new CustomEvent("collection-grid-item:init"));
            document.dispatchEvent(new CustomEvent("cardHover:init"));
            document.dispatchEvent(new CustomEvent("swatch-color:init"));
            document.dispatchEvent(new CustomEvent("update-scroll:init"));
            this.ajaxCollectionEl.classList.remove("preloading");
            document.dispatchEvent(new CustomEvent('filterCTAopacity:init'))
        });
    }
}
  
customElements.define('collection-sorting', collectionSorting);


function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

const filterCTAWrapper = document.querySelector('.mobile-facets__open-wrapper');
const filterCTA = document.querySelector('.mobile-facets__open-wrapper .mobile-facets__open');
if(filterCTA) {
    window.addEventListener('scroll', e => {
        if(window.scrollY > offset(filterCTAWrapper).top) {
            filterCTA.classList.add('sticky-filter-btn')
        } else {
            filterCTA.classList.remove('sticky-filter-btn')
        }
    });
}
